var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{class:_vm.sub ? 'text-h5' : 'text-h4'},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-card-text',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }